export const environment = {
  api: {
    gateway: 'https://dev-extranet.synapse-sante.fr/api/',
    public: 'https://dev-extranet.synapse-sante.fr/',
  },
  host: 'https://extranet-synapse.jcddev.fr',
  ordoclic: {
    iframe_src: 'https://smart.staging.ordoclic.fr/v1/amelipro/launch',
    iframe_tenant: 'fe36257f-f06c-4d20-b257-908cd351c6b3',
    rpps_racine: 90000000001,
    new_dap: 'mock-dap-ppc-initial',
    renew_dap: 'mock-dap-ppc-renew',
  },
  nombreDeJourPourMoyenne: 28,
  version: 'build-' + new Date().getTime(),
};
